var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_1342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C6.93964 0 0 6.93976 0 15.5C0 24.0608 6.93976 31 15.5 31C24.061 31 31 24.0608 31 15.5C31 6.94037 24.061 0.000847656 15.4998 0.000847656L15.5 0ZM22.6081 22.3556C22.3304 22.8109 21.7344 22.9553 21.2791 22.6758C17.6398 20.4529 13.0586 19.9493 7.6633 21.1821C7.41346 21.2389 7.15126 21.1942 6.93436 21.0578C6.71745 20.9214 6.5636 20.7045 6.50661 20.4547C6.47821 20.331 6.47449 20.2029 6.49565 20.0778C6.51681 19.9527 6.56244 19.833 6.62993 19.7256C6.69742 19.6181 6.78544 19.525 6.88895 19.4516C6.99247 19.3782 7.10944 19.326 7.23317 19.2979C13.1377 17.9489 18.2022 18.5296 22.2879 21.0266C22.7432 21.3061 22.8876 21.9003 22.6081 22.3556ZM24.5053 18.1351C24.1553 18.7037 23.4113 18.8832 22.8431 18.5334C18.6768 15.9725 12.3258 15.2308 7.39786 16.7267C6.75873 16.9197 6.08375 16.5596 5.88976 15.9215C5.69722 15.2824 6.05759 14.6086 6.69564 14.4144C12.3247 12.7062 19.3227 13.5337 24.1073 16.4738C24.6755 16.8238 24.8551 17.5677 24.5053 18.1351ZM24.6681 13.7403C19.6725 10.773 11.4305 10.5 6.661 11.9478C5.89509 12.1801 5.08509 11.7477 4.85307 10.9818C4.62094 10.2155 5.05288 9.40608 5.8194 9.17321C11.2944 7.51108 20.3963 7.83234 26.1477 11.2467C26.8381 11.6555 27.0638 12.5453 26.6548 13.2332C26.2477 13.9223 25.3555 14.1493 24.6689 13.7403H24.6681Z",
    fill: "#1ED760"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_1342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.8df20cc831417b2b1beca98d23b5b356.svg";
export { ForwardRef as ReactComponent };